<template>
  <section id="products" class="product-categories section-light">
    <div v-if="loading" class="content-width"><LoadingState /></div>
    <div v-else-if="categories.length" class="product-categories__inner">
      <div v-for="category in categories" :key="category.id" class="category-section">
        <h2 class="section-title">{{ category.name || $store.getters.t('motorcycle') }}</h2>
        <ProductCarousel :products="category.products || []" />
        <div v-if="!(category.products || []).length" class="category-empty">{{ $store.getters.t('noData') }}</div>
      </div>
    </div>
    <div v-else class="content-width"><EmptyState /></div>
  </section>
</template>

<script>
import LoadingState from './LoadingState.vue'
import EmptyState from './EmptyState.vue'
import ProductCarousel from './ProductCarousel.vue'

export default {
  name: 'ProductCategorySection',
  components: { LoadingState, EmptyState, ProductCarousel },
  props: { categories: { type: Array, default: () => [] }, loading: Boolean }
}
</script>
